import { onMounted, onUnmounted, ref } from 'vue'



function useCountdown(totalSeconds) {
    let count = ref(totalSeconds)
    let timer = null

    // 开始倒计时
    const startCountdown = () => {
        clearInterval(timer)

        timer = setInterval(() => {
            count.value--
            if (count.value <= 0) {
                stopCountdown()
            }
        }, 1000)
    }

    // 清除倒计时
    const stopCountdown = () => {
        clearInterval(timer)
    }

    // 组件挂载的时候开始定时器
    onMounted(() => {
        startCountdown()
    })

    // 组件卸载的时候停止定时器
    onUnmounted(() => {
        stopCountdown()
    })

    return {
        remainingSeconds: count,
        startCountdown,
        stopCountdown
    }

}

export default useCountdown